import React, { Component } from 'react';
import ColumnRenderer from '../../util/ColumnRenderer';
import ColumnsSelector from '../ColumnsSelector';
import { ORDER_BY } from '../../util/enums/EnumLayers';

class ModalOrderBy extends Component {
  static modalType() {
    return ORDER_BY;
  }

  static reducer(modals) {
    return modals.orderByModal;
  }

  static title() {
    return 'Sort';
  }

  static subTitle() {
    return (
      <span>
        Sort the results in ascending or descending order, based on one or
        multiple columns.
      </span>
    );
  }

  render() {
    const { state, userInteraction, usedAliases } = this.props;
    let { columns } = this.props;
    columns = columns.filter(
      (c) => !state.selected.some((o) => o.columnName().equals(c.name())),
    ); // don't let user select same column twice
    columns = columns.filter((c) => c.type().operators()); // only allow sorting on types that support comparison (e.g. json doesn't)

    const renderer = new ColumnRenderer(
      'addColumn',
      userInteraction,
      usedAliases,
    );
    let options = (
      <ColumnsSelector
        values={columns.map((c) => c.name())}
        renderer={renderer}
      />
    );

    // a selected column to sort by
    const selected = state.selected.map((o, i) => {
      const removeColumn = {
        section: 'removeColumn',
        columnName: o.columnName(),
      };
      const toggleDir = { section: 'toggleDir', columnName: o.columnName() };
      const direction = o.desc() ? (
        <span className="glyphicon glyphicon-sort-by-attributes-alt" />
      ) : (
        <span className="glyphicon glyphicon-sort-by-attributes" />
      );
      return (
        <div className="sortSelectedOption" key={o.columnName().toString()}>
          <div className="sortBy">{i === 0 ? 'Sort by' : 'then by'}</div>
          <div className="sortColumn btn-group btn-group-no-wrap">
            <button
              type="button"
              className="btn btn-outline-dark"
              onClick={userInteraction(removeColumn)}
            >
              {o.columnName().name()}
            </button>
            <button
              type="button"
              className="btn btn-outline-dark"
              onClick={userInteraction(toggleDir)}
            >
              {direction}
            </button>
          </div>
          <button
            type="button"
            className="btn btn-outline-dark"
            onClick={userInteraction(removeColumn)}
          >
            <span className="glyphicon glyphicon-remove" />
          </button>
        </div>
      );
    });

    const limitStyle = {
      display: 'flex',
      width: '150px',
      marginLeft: 'auto',
      flexDirection: 'row',
      alignItems: 'center',
    };
    const limit = (
      <div style={limitStyle}>
        <span style={{ padding: '10px' }}>Limit</span>
        <input
          onChange={(e) =>
            userInteraction({ section: 'limit', value: e.target.value })()
          }
          value={state.limit || ''}
          placeholder="none"
          type="number"
          className="form-control"
        />
      </div>
    );

    // show either an "add sort" button OR an input with a list of options
    // let emptySpace = (<input type="text" className="form-control" disabled/>);

    if (state.selected.length > 0 && !state.plusClicked) {
      options = [];
    }
    return (
      <div className="sortModalContainer">
        {selected}
        {options}
        {state.selected.length > 0 &&
        !state.plusClicked &&
        state.selected.length !== this.props.columns.length ? (
          <div>
            <hr />
            <div className="modalAddOption">
              <button
                type="button"
                className="btn btn-outline-dark btn-md btn-add-option"
                onClick={userInteraction({ section: 'plusClicked' })}
              >
                Add another sort column
              </button>
            </div>
          </div>
        ) : null}
        {limit}
      </div>
    );
  }
}

export default ModalOrderBy;
